import { Box, FloraTypography, Image } from '@grupoboticario/flora-react'

import { PREVIEW_LABELS } from '@/constants/eventPreviewLabels'

import { imagePreviewStyle, noImageBoxStyle, noImageTextStyle } from './styles'

const ImagePreview = ({ imageUrl }) =>
  imageUrl ? (
    <Image alt="Preview do evento" css={imagePreviewStyle} src={imageUrl} />
  ) : (
    <Box css={noImageBoxStyle}>
      <FloraTypography css={noImageTextStyle} fontSize="bodyLargeStandard">
        {PREVIEW_LABELS.NO_IMAGE}
      </FloraTypography>
    </Box>
  )

export default ImagePreview
